import PublicTemplate from "../PublicTemplate/PublicTemplate";
import React, {useEffect, useState} from "react";
import {useLocation, useParams} from "react-router-dom";
import * as publicActions from "../PublicActions/PublicActions";
import "./PublicForm.scss";
import PublicFormDisplay from "../PublicFormDisplay/PublicFormDisplay";

const PublicForm = () => {
    const [droppedItems, setDroppedItems] = useState([]);
    const {publicId} = useParams();
    const [allFormsPublicId, setAllFormsPublicId] = useState("");
    const [savedVariables, setSavedVariables] = useState({});
    const [savedData, setSavedData] = useState({});
    const [requiresSignature, setRequiresSignature] = useState(true);
    const [formName, setFormName] = useState();
    const {state} = useLocation();
    const {publicCustomerId} = state;
    const [rootItems, setRootItems] = useState([]);

    useEffect(() => {
        if (publicId) {
            const data = {"publicCustomerId": publicCustomerId}

            publicActions.getPublicForm(publicId, data, (res) => {
                if (res) {
                    setAllFormsPublicId(res.publicId);
                    setSavedVariables(res.variables);
                    setSavedData(res.data);
                    if (res.form) {
                        setFormName(res.form.name);
                        setRequiresSignature(res.form.requiresSignature);
                        if (res.form.content && res.form.content.droppedItems) {
                            setDroppedItems(res.form.content.droppedItems);
                            setRootItems(res.form.content.droppedItems.filter(item => !item?.parentId))
                        }
                    }
                }
            });
        }
    }, [publicId]);

    return (
        <PublicTemplate>
            <div className="foreign">
                <p>{formName}</p>
            </div>
            <div className="public-form">
                <PublicFormDisplay
                    formName={formName}
                    requiresSignature={requiresSignature}
                    publicId={publicId}
                    publicCustomerId={publicCustomerId}
                    allFormsPublicId={allFormsPublicId}
                    savedVariables={savedVariables}
                    savedData={savedData}
                    rootItems={rootItems}
                    droppedItems={droppedItems}
                />
            </div>

        </PublicTemplate>
    )
}

export default PublicForm;